import * as React from 'react';
import * as style from './style.css';

import { ITransportPointExtendedCell } from '../../../../../../types/newbuildingsCompare';
import { TransportPointRow } from './parts';

export interface ITransportPointExtendedCellProps {
  cell: ITransportPointExtendedCell;
}

export const TransportPointExtendedCell = ({ cell }: ITransportPointExtendedCellProps): React.JSX.Element => (
  <div className={style['container']}>
    {cell.data?.transportPoints &&
      cell.data.transportPoints.map(item => <TransportPointRow key={item.name} item={item} />)}
  </div>
);
